import { isRouted, type IRouteService } from './routerTypes.js'
import { Route } from './route.js'
import { HistorySync, type Action } from './history.js'
import type { IApp } from '../component/componentTypes.js'
import type { Router } from './router.js'

export interface RouteServiceOptions {
  basePath?: string
}

export class RouteService implements IRouteService {
  private _basePath: Route  
  private _history?: HistorySync
  private _root!: Router
  currentRoute: Route = new Route("")

  get basePath(): Route { return this._basePath }
  get root(): Router { return this._root }

  constructor(options: RouteServiceOptions = {}) {
    this._basePath = new Route (options.basePath ?? "")
  }

  syncHistory(action: Action): void {
    this._history?.sync(action)
  }

  restoreHistory(): void {
    this._history?.restore()
  }

  init(app: IApp): void {
    const root = app.root
    if (!isRouted(root)) return
    
    root.router.routeService = this
    this._root = root.router
    this._history = new HistorySync(this)
    this._history.ensureListener()
    const loc = window.location
    this.navigateAbsolute(new Route(loc.pathname + loc.search), 'POP')
  }

  navigateAbsolute(absolute: Route, action: Action): Promise<boolean> {
    const rel = absolute.relativeTo(this._basePath)
    return this.root.navigate(rel, action)
  }
}
